import React from "react";
import PropTypes from "prop-types";
import DOMPurify from "dompurify";
import { buildScopeTranslate } from "lib/I18n";
import { getGradeStyle, refPropType } from "../utils";
import { GRADE_LABEL_KEYS } from "../constants";

const FEEDBACK_PURIFY_CONFIG = { ALLOWED_TAGS: ['p', 'strong', 'em', 'ul', 'li'] };

const tLabels = buildScopeTranslate("views.content.agentforce.assessments.labels");

const FeedbackCard = ({ response, gradeTabbable = false, gradeRef = null }) => {
  const gradeStyle = getGradeStyle(response.agentGrade);
  const { pointScore, maxPoints } = response;
  const gradeLabelKey = GRADE_LABEL_KEYS[response.agentGrade];
  const gradeLabel = gradeLabelKey ? tLabels(gradeLabelKey) : gradeStyle.label;
  const shouldShowPoints = pointScore !== undefined && maxPoints !== undefined;
  const accessibleLabel = shouldShowPoints
    ? tLabels("grade_score_accessible", { grade: gradeLabel, points: pointScore, max: maxPoints })
    : gradeLabel;

  return (
    <div
      className="slds-p-around_medium th-agentforce-assessment__feedback-card"
      style={{
        border: `1px solid ${gradeStyle.color}`,
      }}
      data-testid="feedback-card">
      <div className="slds-grid th-agentforce-assessment__feedback-grid">
        <div className="slds-shrink">
          <div
            className="th-agentforce-assessment__feedback-icon-badge"
            style={{ backgroundColor: gradeStyle.color }}>
            <tds-icon symbol={gradeStyle.icon} size="x-small" aria-hidden="true"></tds-icon>
          </div>
        </div>
        <div className="slds-grow">
          <h2
            ref={gradeRef}
            className="slds-text-body_regular tds-text_bold slds-m-bottom_xx-small th-agentforce-assessment__feedback-title"
            style={{ color: gradeStyle.color }}
            data-testid="feedback-score-display"
            tabIndex={gradeTabbable ? "0" : "-1"}
            aria-label={accessibleLabel}>
            <span aria-hidden="true">
              {gradeLabel}
              {shouldShowPoints && (
                <span> • {pointScore}/{maxPoints}</span>
              )}
            </span>
          </h2>
          <div
            className="slds-text-body_regular"
            data-testid="feedback-message-text"
            tabIndex="0"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(response.agentFeedback, FEEDBACK_PURIFY_CONFIG) }}
          />
        </div>
      </div>
    </div>
  );
};

FeedbackCard.propTypes = {
  response: PropTypes.shape({
    agentGrade: PropTypes.string,
    agentFeedback: PropTypes.string,
    pointScore: PropTypes.number,
    maxPoints: PropTypes.number,
  }).isRequired,
  gradeTabbable: PropTypes.bool,
  gradeRef: refPropType,
};

export default FeedbackCard;
